const CONNECTION = "We couldn’t reach SideQuest HQ. Check your connection and try again.";
const FALLBACK = "Something went sideways. Please try again.";

// Codes whose SDK messages are technical rather than written for players.
const MESSAGES_BY_CODE: Record<string, string> = {
  internal: FALLBACK,
  unknown: FALLBACK,
  unavailable: CONNECTION,
  "deadline-exceeded": "That took too long. Check your connection and try again.",
  cancelled: "That request was cancelled. Please try again.",
  unauthenticated: "Your sign-in has expired. Sign in again to continue.",
  "network-request-failed": CONNECTION,
  "popup-closed-by-user": "Sign-in was cancelled before it finished.",
  "cancelled-popup-request": "Sign-in was cancelled before it finished.",
  "popup-blocked": "Your browser blocked the sign-in window. Allow pop-ups for this site and try again.",
  "too-many-requests": "Too many attempts. Wait a moment, then try again.",
};

const NETWORK_FAILURE = /^(failed to fetch|load failed|networkerror when attempting to fetch resource\.?|network ?error|the network connection was lost\.?)$/i;

/** Turns SDK, network and server errors into a sentence that is safe to show players. */
export function friendlyError(error: unknown): string {
  if (!error || typeof error !== "object" || !("message" in error)) return FALLBACK;
  const code = "code" in error && typeof error.code === "string" ? error.code.replace(/^[a-z]+\//, "") : "";
  const message = String(error.message)
    .replace(/^Firebase:\s*/i, "")
    .replace(/\s*\((?:functions|auth)\/[a-z-]+\)\.?$/i, "")
    .replace(/\s*\[\d{1,3}\]$/, "")
    .replace(/^Error$/i, "")
    .trim();
  if (NETWORK_FAILURE.test(message)) return CONNECTION;
  const technical = !message || message.toLowerCase() === code || message.toLowerCase().replace(/\s+/g, "-") === code
    || /^(?:unknown )?backend error status\b/i.test(message) || /^response is (?:not valid|missing)/i.test(message);
  // Sign-in errors never carry a player-facing message of their own.
  const signInCode = /^(?:popup-|cancelled-popup|network-request-failed|too-many-requests)/.test(code);
  if (code in MESSAGES_BY_CODE && (technical || signInCode)) return MESSAGES_BY_CODE[code];
  if (technical) return MESSAGES_BY_CODE[message.toLowerCase()] ?? FALLBACK;
  return message;
}
